/* Nutra Essentia — theme.js v7 */
(function(){
'use strict';

// ── HERO SLIDER ────────────────────────────────────────────
var slides, dots, current = 0, timer;
function initSlider(){
  // Match data attributes used in homepage.liquid
  slides = Array.from(document.querySelectorAll('[data-hero-slide]'));
  dots   = Array.from(document.querySelectorAll('[data-hero-dot]'));
  if(!slides.length) return;
  var nxt = document.querySelector('[data-hero-next]');
  var prv = document.querySelector('[data-hero-prev]');
  if(nxt) nxt.addEventListener('click', function(){ goTo(current+1); resetTimer(); });
  if(prv) prv.addEventListener('click', function(){ goTo(current-1); resetTimer(); });
  dots.forEach(function(d){
    d.addEventListener('click', function(){ goTo(parseInt(d.dataset.heroDot||d.dataset.index||0)); resetTimer(); });
  });
  var stage = document.querySelector('[data-hero-stage]');
  if(stage){
    stage.addEventListener('mouseenter', function(){ clearInterval(timer); });
    stage.addEventListener('mouseleave', function(){ resetTimer(); });
  }
  showSlide(0);
  resetTimer();
}
function showSlide(n){
  current = ((n % slides.length) + slides.length) % slides.length;
  slides.forEach(function(s, i){
    var on = i === current;
    s.style.opacity = on ? '1' : '0';
    s.style.pointerEvents = on ? 'auto' : 'none';
    s.style.transition = 'opacity 0.9s ease';
  });
  dots.forEach(function(d, i){
    var on = i === current;
    d.style.width = on ? '26px' : '8px';
    d.style.background = on ? '#1B4332' : 'rgba(26,37,32,0.22)';
  });
}
function goTo(n){ showSlide(n); }
function resetTimer(){ clearInterval(timer); timer = setInterval(function(){ goTo(current+1); }, 5500); }

// ── CART DRAWER ────────────────────────────────────────────
var cartOpen = false;
function initCart(){
  var toggle  = document.getElementById('cartToggle');
  var drawer  = document.getElementById('cartDrawer');
  var overlay = document.getElementById('cartOverlay');
  var close   = document.getElementById('cartClose');
  if(!toggle || !drawer) return;
  toggle.addEventListener('click', function(){ cartOpen ? closeDrawer() : openDrawer(); });
  if(close)   close.addEventListener('click', closeDrawer);
  if(overlay) overlay.addEventListener('click', closeDrawer);
}
function openDrawer(){
  cartOpen = true;
  var d = document.getElementById('cartDrawer');
  var o = document.getElementById('cartOverlay');
  if(d){ d.classList.add('open'); d.setAttribute('aria-hidden','false'); }
  if(o) o.classList.add('open');
  document.body.style.overflow = 'hidden';
  fetchCart();
}
function closeDrawer(){
  cartOpen = false;
  var d = document.getElementById('cartDrawer');
  var o = document.getElementById('cartOverlay');
  if(d){ d.classList.remove('open'); d.setAttribute('aria-hidden','true'); }
  if(o) o.classList.remove('open');
  document.body.style.overflow = '';
}
function fetchCart(){
  fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCart).catch(function(){});
}
function renderCart(cart){
  var items = document.getElementById('cartItems');
  var foot  = document.getElementById('cartFoot');
  var sub   = document.getElementById('cartSubtotal');
  var note  = document.getElementById('cartShipNote');
  var cnt   = document.getElementById('cartCount');
  if(cnt) cnt.textContent = cart.item_count;
  if(!items) return;
  if(!cart.item_count){
    items.innerHTML = '<p style="padding:32px 24px;color:#8FA192;text-align:center;">Your bag is empty</p>';
    if(foot) foot.style.display='none';
    return;
  }
  items.innerHTML = cart.items.map(function(item){
    var price = (item.line_price/100).toLocaleString('en-GB',{style:'currency',currency:'GBP'});
    return '<div class="cart-di">'
      +'<img src="'+item.image+'" alt="'+item.title+'" loading="lazy">'
      +'<div class="cart-di-info">'
      +'<div class="cart-di-title">'+item.title+'</div>'
      +(item.variant_title&&item.variant_title!=='Default Title'?'<div class="cart-di-variant">'+item.variant_title+'</div>':'')
      +'<div class="cart-di-row">'
      +'<div class="cart-di-qty">'
      +'<button class="cart-di-qbtn" data-line="'+item.key+'" data-delta="-1">&#8722;</button>'
      +'<span>'+item.quantity+'</span>'
      +'<button class="cart-di-qbtn" data-line="'+item.key+'" data-delta="1">&#43;</button>'
      +'</div>'
      +'<span class="cart-di-price">'+price+'</span>'
      +'</div>'
      +'<button class="cart-di-remove" data-line="'+item.key+'">Remove</button>'
      +'</div></div>';
  }).join('');
  items.querySelectorAll('.cart-di-qbtn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var key = btn.dataset.line;
      var delta = parseInt(btn.dataset.delta);
      var cur = parseInt(btn.closest('.cart-di').querySelector('span').textContent);
      updateCart(key, Math.max(0, cur+delta));
    });
  });
  items.querySelectorAll('.cart-di-remove').forEach(function(btn){
    btn.addEventListener('click', function(){ updateCart(btn.dataset.line, 0); });
  });
  var total = (cart.total_price/100).toLocaleString('en-GB',{style:'currency',currency:'GBP'});
  if(sub) sub.textContent = 'Subtotal: '+total;
  var remaining = 35 - cart.total_price/100;
  if(note) note.textContent = remaining>0 ? 'Add £'+remaining.toFixed(2)+' more for free UK delivery' : '✓ Free UK delivery included';
  if(foot) foot.style.display='block';
}
function updateCart(key, qty){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
    .then(function(r){ return r.json(); }).then(renderCart).catch(function(){});
}

// ── ADD TO CART ────────────────────────────────────────────
function initAddToCart(){
  var form = document.getElementById('pdp-form');
  if(!form) return;
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var id  = form.querySelector('[name="id"]');
    var qty = document.getElementById('qtyInput');
    if(!id) return;
    var btn = form.querySelector('button[type="submit"]');
    if(btn){ btn.textContent='Adding…'; btn.disabled=true; }
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:parseInt(id.value),quantity:parseInt(qty?qty.value:1)}]})
    })
    .then(function(r){ return r.json(); })
    .then(function(d){
      if(btn){ btn.textContent='Add to Bag'; btn.disabled=false; }
      if(d.status){ showToast('Error: '+d.description); return; }
      showToast((d.items?d.items[0].title:d.title)+' added to bag');
      fetchCart(); openDrawer();
    })
    .catch(function(){ if(btn){ btn.textContent='Add to Bag'; btn.disabled=false; } showToast('Could not add — please try again'); });
  });
}

// ── PRODUCT GALLERY ────────────────────────────────────────
function initGallery(){
  var main = document.getElementById('galMain');
  if(!main) return;
  document.querySelectorAll('.pdp-thumb').forEach(function(t){
    t.addEventListener('click', function(){
      main.src = t.dataset.src;
      document.querySelectorAll('.pdp-thumb').forEach(function(x){ x.classList.remove('ne-active'); });
      t.classList.add('ne-active');
    });
  });
}

// ── FAQ ────────────────────────────────────────────────────
function initFAQ(){
  document.querySelectorAll('[data-faq-btn]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var ans  = btn.nextElementSibling;
      var icon = btn.querySelector('[data-faq-ic]');
      var isOpen = ans && ans.style.maxHeight && ans.style.maxHeight !== '0px' && ans.style.maxHeight !== '0';
      // Close all
      document.querySelectorAll('[data-faq-ans]').forEach(function(a){ a.style.maxHeight='0px'; a.style.overflow='hidden'; });
      document.querySelectorAll('[data-faq-ic]').forEach(function(i){ i.textContent='+'; });
      // Open this one if it was closed
      if(!isOpen && ans){
        ans.style.maxHeight = ans.scrollHeight + 'px';
        ans.style.overflow = 'visible';
        if(icon) icon.textContent='−';
      }
    });
  });
}

// ── SUBSCRIPTION TOGGLE ────────────────────────────────────
function initSubToggle(){
  var btnOne  = document.getElementById('btnOneTime');
  var btnSub  = document.getElementById('btnSub');
  var priceEl = document.getElementById('pdpPrice');
  var cmpEl   = document.getElementById('pdpCompare');
  var noteEl  = document.getElementById('pdpNote');
  if(!btnOne || !priceEl) return;
  var basePrice = parseFloat(priceEl.textContent.replace(/[^0-9.]/g,''));
  var subPrice  = Math.round(basePrice*85)/100;
  function fmt(n){ return '£'+n.toFixed(2); }
  var subInfo = document.getElementById('subInfo');
  btnOne.addEventListener('click', function(){
    btnOne.classList.add('ne-active'); btnSub.classList.remove('ne-active');
    priceEl.textContent=fmt(basePrice);
    if(cmpEl) cmpEl.textContent='';
    if(noteEl) noteEl.textContent='One-time purchase';
    if(subInfo) subInfo.style.display='none';
  });
  btnSub.addEventListener('click', function(){
    btnSub.classList.add('ne-active'); btnOne.classList.remove('ne-active');
    priceEl.textContent=fmt(subPrice);
    if(cmpEl) cmpEl.textContent=fmt(basePrice);
    if(noteEl) noteEl.textContent='Subscribe & save 15% · Cancel anytime · Free UK delivery';
    if(subInfo) subInfo.style.display='block';
  });
}

// ── QUANTITY ───────────────────────────────────────────────
function initQty(){
  var dec=document.getElementById('qtyDec'), inc=document.getElementById('qtyInc');
  var val=document.getElementById('qtyVal'), input=document.getElementById('qtyInput');
  if(!dec) return;
  var qty=1;
  dec.addEventListener('click',function(){ qty=Math.max(1,qty-1); val.textContent=qty; input.value=qty; });
  inc.addEventListener('click',function(){ qty=Math.min(6,qty+1); val.textContent=qty; input.value=qty; });
}

// ── MOBILE NAV ─────────────────────────────────────────────
function initMobileNav(){
  var toggle = document.getElementById('navToggle');
  var links  = document.getElementById('navLinks');
  if(!toggle||!links||toggle.dataset.ready==='true') return;
  toggle.dataset.ready='true';
  toggle.addEventListener('click', function(){
    var open = links.classList.toggle('open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  });
  links.querySelectorAll('a').forEach(function(link){
    link.addEventListener('click', function(){
      links.classList.remove('open');
      toggle.setAttribute('aria-expanded','false');
      toggle.setAttribute('aria-label','Open menu');
    });
  });
}

function initHeaderSearch(){
  var toggle = document.getElementById('searchToggle');
  var panel = document.getElementById('headerSearch');
  var close = document.getElementById('searchClose');
  var input = document.getElementById('HeaderSearchInput');
  if(!toggle||!panel||toggle.dataset.ready==='true') return;
  toggle.dataset.ready='true';
  function setOpen(open){
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if(open && input) window.setTimeout(function(){ input.focus(); }, 20);
  }
  toggle.addEventListener('click', function(){ setOpen(panel.hidden); });
  if(close) close.addEventListener('click', function(){ setOpen(false); toggle.focus(); });
  document.addEventListener('keydown', function(event){
    if(event.key==='Escape' && !panel.hidden){ setOpen(false); toggle.focus(); }
  });
}

// ── TOAST ──────────────────────────────────────────────────
var toastTimer;
function showToast(msg){
  var el = document.getElementById('ne-toast');
  if(!el) return;
  el.innerHTML='<span style="color:#2BB6BD">&#10003;</span> '+msg;
  el.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(function(){ el.classList.remove('show'); }, 2600);
}

// ── REVIEW FORM ───────────────────────────────────────────
function initReviews(){
  var writeBtn   = document.getElementById('writeReviewBtn');
  var cancelBtn  = document.getElementById('cancelReview');
  var submitBtn  = document.getElementById('submitReview');
  var form       = document.getElementById('reviewForm');
  var starPicks  = document.querySelectorAll('.star-pick');
  var rating     = 0;

  if(writeBtn && form){
    writeBtn.addEventListener('click', function(){
      form.style.display = form.style.display === 'none' ? 'block' : 'none';
      if(form.style.display === 'block') form.scrollIntoView({behavior:'smooth', block:'nearest'});
    });
  }
  if(cancelBtn && form) cancelBtn.addEventListener('click', function(){ form.style.display='none'; });

  // Star picker
  starPicks.forEach(function(star){
    star.addEventListener('mouseover', function(){
      var v = parseInt(star.dataset.val);
      starPicks.forEach(function(s){ s.style.color = parseInt(s.dataset.val) <= v ? '#C9A84C' : 'rgba(26,37,32,.2)'; });
    });
    star.addEventListener('mouseout', function(){
      starPicks.forEach(function(s){ s.style.color = parseInt(s.dataset.val) <= rating ? '#C9A84C' : 'rgba(26,37,32,.2)'; });
    });
    star.addEventListener('click', function(){
      rating = parseInt(star.dataset.val);
      starPicks.forEach(function(s){ s.style.color = parseInt(s.dataset.val) <= rating ? '#C9A84C' : 'rgba(26,37,32,.2)'; });
    });
  });

  // Submit (demo — shows toast since no app installed)
  if(submitBtn){
    submitBtn.addEventListener('click', function(){
      if(!rating){ showToast('Please select a star rating'); return; }
      showToast('Thank you! Install Judge.me to publish live reviews.');
      if(form) form.style.display='none';
      rating=0;
      starPicks.forEach(function(s){ s.style.color='rgba(26,37,32,.2)'; });
    });
  }
}

// ── EMAIL POPUP ───────────────────────────────────────────
function initPopup(){
  var overlay = document.getElementById('nePopupOverlay');
  var close   = document.getElementById('nePopupClose');
  var skip    = document.getElementById('nePopupSkip');
  var form    = document.getElementById('nePopupForm');
  if(!overlay) return;
  // Show after 8 seconds if not dismissed before
  if(!localStorage.getItem('ne_popup_dismissed')){
    setTimeout(function(){ overlay.style.display='flex'; }, 8000);
  }
  function dismiss(){ overlay.style.display='none'; localStorage.setItem('ne_popup_dismissed','1'); }
  if(close) close.addEventListener('click', dismiss);
  if(skip)  skip.addEventListener('click', dismiss);
  overlay.addEventListener('click', function(e){ if(e.target===overlay) dismiss(); });
  if(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var email = document.getElementById('nePopupEmail');
      if(email && email.value){
        showToast('Welcome! Your 10% code: WELCOME10');
        dismiss();
        localStorage.setItem('ne_popup_dismissed','1');
      }
    });
  }
}

// ── STICKY BAR ─────────────────────────────────────────────
function initStickyBar(){
  var bar    = document.getElementById('stickyBar');
  var buyBtn = document.querySelector('#pdp-form');
  if(!bar || !buyBtn) return;
  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      bar.style.transform = entry.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
    });
  }, { threshold: 0.1 });
  observer.observe(buyBtn);
}

// ── PRODUCT IMAGE ZOOM ─────────────────────────────────────
function initZoom(){
  var main = document.getElementById('galMain');
  if(!main) return;
  main.style.cursor = 'zoom-in';
  var zoomed = false;
  var overlay = document.createElement('div');
  overlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,.85);z-index:400;align-items:center;justify-content:center;cursor:zoom-out;';
  var zImg = document.createElement('img');
  zImg.style.cssText = 'max-width:90vw;max-height:90vh;object-fit:contain;border-radius:8px;';
  overlay.appendChild(zImg);
  document.body.appendChild(overlay);
  main.addEventListener('click', function(){
    zImg.src = main.src;
    overlay.style.display='flex';
  });
  overlay.addEventListener('click', function(){ overlay.style.display='none'; });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') overlay.style.display='none'; });
}

// ── RECENTLY VIEWED ───────────────────────────────────────
function initRecentlyViewed(){
  var section = document.getElementById('recentlyViewedSection');
  var grid    = document.getElementById('recentlyViewedGrid');
  // Save current product to localStorage
  var metaHandle = document.querySelector('meta[property="og:url"]');
  var titleEl    = document.querySelector('meta[property="og:title"]');
  var imgEl      = document.querySelector('meta[property="og:image"]');
  var priceEl    = document.querySelector('meta[property="product:price:amount"]');
  if(titleEl && imgEl){
    var url   = window.location.pathname;
    var title = titleEl.content.replace(/s*|.*$/, '');
    var img   = imgEl.content;
    var price = priceEl ? '£'+parseFloat(priceEl.content).toFixed(2) : '';
    var rv    = JSON.parse(localStorage.getItem('ne_rv') || '[]');
    rv = rv.filter(function(p){ return p.url !== url; });
    rv.unshift({ url:url, title:title, img:img, price:price });
    rv = rv.slice(0, 5);
    localStorage.setItem('ne_rv', JSON.stringify(rv));
    // Show others
    var others = rv.filter(function(p){ return p.url !== url; });
    if(others.length && section && grid){
      section.style.display = 'block';
      grid.innerHTML = others.map(function(p){
        return '<a href="'+p.url+'" style="text-decoration:none;background:#fff;border-radius:16px;overflow:hidden;width:200px;flex-shrink:0;border:1px solid rgba(26,37,32,.08);">'
          +'<div style="height:160px;display:flex;align-items:center;justify-content:center;padding:16px;background:#fff;">'
          +'<img src="'+p.img+'" alt="'+p.title+'" style="height:100%;object-fit:contain;mix-blend-mode:multiply;">'
          +'</div>'
          +'<div style="padding:12px 14px 16px;">'
          +'<div style="font-family:\'Newsreader\',serif;font-size:15px;color:#16271E;margin-bottom:4px;">'+p.title+'</div>'
          +'<div style="font-size:13\px;font-wei\ght:700;color:#1B4332;">'+p.price+'</div>'
          +'</div></a>';
      }).join('');
    }
  }
}

// ── UPSELL TOAST (after add to cart) ──────────────────────
function initUpsell(){
  // After adding to cart, suggest a complementary product
  var upsells = {
    'shilajit-pure-resin': { title:'Shilajit Complex', url:'/products/shilajit-complex', msg:'Complete the ritual' },
    'shilajit-complex': { title:'Magnesium Bisglycinate', url:'/products/magnesium-bisglycinate', msg:'Pairs perfectly with' },
    'turmeric-curcumin': { title:'Magnesium Bisglycinate', url:'/products/magnesium-bisglycinate', msg:'Often bought together' },
    'magnesium-bisglycinate': { title:'Shilajit Complex', url:'/products/shilajit-complex', msg:'Customers also love' }
  };
  var handle = window.location.pathname.split('/products/')[1];
  if(!handle) return;
  var upsell = upsells[handle];
  if(!upsell) return;
  // Show upsell 3s after add to cart
  var form = document.getElementById('pdp-form');
  if(!form) return;
  form.addEventListener('submit', function(){
    setTimeout(function(){
      var el = document.getElementById('ne-toast');
      if(!el) return;
      el.innerHTML = '<span style="color:#2BB6BD">✓</span> Added! '
        + upsell.msg+': <a href="'+upsell.url+'" style="color:#2BB6BD;font-weight:700;text-decoration:underline;">'+upsell.title+'</a>';
      el.classList.add('show');
      setTimeout(function(){ el.classList.remove('show'); }, 4000);
    }, 3000);
  });
}

// ── INIT ───────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function(){
  initSlider();
  initCart();
  initAddToCart();
  initGallery();
  initFAQ();
  initSubToggle();
  initQty();
  initMobileNav();
  initHeaderSearch();
  initReviews();
  initPopup();
  initStickyBar();
  initZoom();
  initRecentlyViewed();
  initUpsell();
});

// ── SHOPIFY THEME EDITOR LIVE RELOAD ──────────────────────
if(window.Shopify && window.Shopify.designMode){
  document.addEventListener('shopify:section:load', function(e){
    initSlider();
    initFAQ();
    initSubToggle();
    initGallery();
    initCart();
    initMobileNav();
    initHeaderSearch();
  });
  document.addEventListener('shopify:section:select', function(){
    initSlider();
  });
}
})();